import AiChatSystem from '../pages/AiChatSystem';

const aiChatRoutes = [
  {
    path: '/ai-chat',
    Component: AiChatSystem,
  }
];

export default aiChatRoutes;
